import {useNews} from '@/hooks/useNews.ts';
import NewsGrid from "../../../components/NewsGrid.tsx";
import ProgramsPage from "../../programs/pages/ProgramsPage.tsx";
import {HomeBanner} from "@/components/HomeBanner.tsx";
import ContactUs from "@/features/home/components/ContactUsPage.tsx";
import ContentBanner from "@/components/ContentBanner.tsx";
import HotStoriesBanner from "@/features/news/pages/HotStoriesBanner.tsx";
import NamEventsSection from "@/features/home/components/NamEventsSection.tsx";
import {MetaTags} from "@/hooks/MetaTags.tsx";

export default function HomePage() {

    const {data: result, isLoading, isError} = useNews(false, {
        page: 0,
        size: 12,
        sortBy: "publishedAt",
        sortOrder: "desc"
    });

    return (
        <>
            <MetaTags
                title={"Kosmos 94.1 - Namibië se gunsteling Afrikaanse radiostasie"}
                description={"Kosmos 94.1 is Namibië se gunsteling Afrikaanse radiostasie."}
            />

            <HomeBanner/>

            <HotStoriesBanner/>

            <section className="bg-white py-16 sm:py-22">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-4xl font-semibold tracking-tight text-blue-900 sm:text-5xl">
                            Jongste Nuus
                        </h2>
                        <p className="mt-2 text-lg/8 text-gray-600">Bly op hoogte met die jongste nuus van hier, daar en
                            oral.</p>
                    </div>

                    <div className="mt-8">
                        <NewsGrid
                            content={result}
                            isLoading={isLoading}
                            isError={isError}
                            showPagination={false}
                            showTags={false}
                            setPage={() => {
                            }}
                        />
                    </div>
                </div>

                <ContentBanner className="px-6" placement={"HOME_MIDDLE"}/>

                <ProgramsPage/>

                {/*<LatestKosmosVideos count={3}/>*/}

                <ContentBanner className="px-6" placement={"HOME_BOTTOM"}/>

                <NamEventsSection/>

            </section>
            <ContactUs/>
        </>
    )
}